import React from 'react';
import { connect } from "react-redux";
import './../main.scss'
import './../../main.css'
import { withNamespaces } from 'react-i18next';
import { Col, Row } from 'react-bootstrap';

export class Total extends React.Component{

   
    render(){  
        const { t } = this.props
        const rowLen = this.props.list.length;
        return(    
            <Row className="total_users">
                <span className="mb-2">{t('Total by country')}</span>                
                <div className="recharts-surface p-4" id="tabs" >
                    {this.props.list.map((data,index) => {
                        return <Col key={index}>
                            <h5>{data.countryName}</h5>
                            <p>{t('With PDV')} : {data?.amountWithPdv?.toFixed(2)} &nbsp;I&nbsp;&nbsp;
                            {t('Without PDV')} : {data?.amountWithoutPdv?.toFixed(2)}</p>
                            {rowLen !== index + 1 && <hr />}
                        </Col>
                    })}
                </div>
            </Row>
        )
    }  
}

const mapStateToProps = state => {
    return {
        list: state.dashboard.amountByCountry
    };
};
  
const mapDispatchToProps = dispatch => {
    return {
      mapState: (type, data) => dispatch({ type: type, data: data}),
      API: (type, data) => dispatch({ type: type, data: data})
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withNamespaces()(Total));
